import { h } from 'preact'
import classNames from 'classnames'

import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import {Badge, BadgeList} from "./index";
import DropdownImage from "../dropdown/DropdownImage";

function normalizeBadges (badgeList: BadgeList, onChange: Function) {
  return badgeList.map((badge: Badge) => {
    return {
      value: badge.id,
      title: badge.title,
      image: badge.image,
      onClick: (e: Event) => onChange((e.target as HTMLElement).getAttribute('value')),
      variant: 'primary'
    }
  })
}

const BadgeSelector = ({
  badges,
  selected,
  onChange,
  error
}: {
  badges: BadgeList,
  selected: Badge | undefined,
  onChange: Function,
  error: string | undefined
}) => {
  const normalizedBadges = badges && normalizeBadges(badges, onChange)

  const DropdownText = () => {
    if(badges.length === 0) return 'There are no badges available'
    return selected ?
        <span class='selected'>
            <div>{ selected.image && <DropdownImage image={ selected.image} /> }</div>
            <div class='truncated'>{selected.title}</div>
        </span>
        : 'Choose a badge'
  }

  const className = classNames('badge-selector qa-badge-selector', error && 'error', !selected && 'no-badge-selected-message')

  return <div class='badge-selector-wrapper'>
    <DropdownControl
        align='adjust'
        // @ts-ignore
        trigger={<ButtonControl title={<DropdownText />} class={className} icon={'arrowDropdown'} />}
        items={normalizedBadges}
        hasSearch={true}
        closeOnDropdownClick
    />
    {error && <span class='error'>{error}</span>}
  </div>
}

export default BadgeSelector
